import { bodyInfo } from "@solar/ephemeris";
import { useScene, useTimeMs } from "../store";
import { bodyName, useT } from "../i18n";
import { computeInfo } from "./infoData";

export function InfoCard({ onAsk }: { onAsk: () => void }) {
  const { t, lang } = useT();
  const selected = useScene((s) => s.selected);
  const ms = useTimeMs(250);
  if (!selected) return null;
  const d = computeInfo(selected, new Date(ms));
  const name = bodyName(selected, lang);
  const fmtPeriod = (days: number) => (days > 800 ? `${(days / 365.25).toFixed(1)} ${t("years")}` : `${days.toFixed(days < 100 ? 1 : 0)} ${t("days")}`);
  const fmtRot = (h: number) => `${h > 48 ? `${(h / 24).toFixed(2)} ${t("days")}` : `${h.toFixed(2)} ${t("hours")}`}${d.retrograde ? ` (${t("retro")})` : ""}`;
  const kv: [string, string][] = [
    [t("distSun"), `${d.distSunAU.toFixed(4)} AU`],
    [t("distEarth"), selected === "earth" ? "—" : `${d.distEarthAU.toFixed(selected === "moon" ? 5 : 4)} AU`],
    [t("period"), d.periodDays ? fmtPeriod(d.periodDays) : "—"],
    [t("sma"), d.a ? `${d.a.toFixed(selected === "moon" ? 5 : 3)} AU` : "—"],
    [t("ecc"), d.e !== null ? d.e.toFixed(4) : "—"],
    [t("obliq"), d.obliquityDeg !== null ? `${d.obliquityDeg.toFixed(1)}°` : t("noRotation")],
    [t("rotPeriod"), d.rotHours ? fmtRot(d.rotHours) : t("noRotation")],
    [`${t("diameter")} (${t("unverified")})`, `${Math.round(d.diameterKm).toLocaleString()} km`],
  ];
  return (
    <section className="info glass">
      <h3>{name}<small>{bodyInfo(selected).nameEn.toUpperCase()}</small></h3>
      <div className="kv" style={{ marginTop: 10 }}>
        {kv.map(([k, v]) => (<div key={k}><span>{k}</span><b className="num">{v}</b></div>))}
        <div className="wide"><span>{t("position")}</span><b className="num">{t("lon")} {d.lonDeg.toFixed(2)}° · {d.distSunAU.toFixed(3)} AU</b></div>
      </div>
      <p className="note">{t("infoNote")}</p>
      <div className="btns"><button className="btn pri" onClick={() => useScene.getState().select(selected)}>{t("flyTo")}</button><button className="btn" onClick={onAsk}>{t("askAi")}</button></div>
    </section>
  );
}
